"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6743 4H17.326l-1.1733 4.1058C18.0784 9.6525 19.0094 11.833 19 14c-.0119 2.7584-1.4014 5.4694-3.6973 7H8.6973c-2.2959-1.5306-3.6854-4.2416-3.6972-7-.0094-2.167.9218-4.3475 2.8474-5.8942L6.6743 4zM9.326 6l.8364 2.9271C8.369 10.1226 6.9903 11.7145 7 14c.0088 2.0411 1.0786 4.0288 2.3226 5h5.3548c1.244-.9712 2.3138-2.9588 2.3226-5 .0099-2.2855-1.3688-3.8774-3.1621-5.0729L14.6744 6H9.3259z"
  })];
};

exports.default = _default;